import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex-shrink: 0;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Popover } from '@scp/ui-shared/components/popover';
import { Icon } from '@scp/ui-shared/theme/icons';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { IconButton } from './IconButton';
var TEXT = {
  COPY_LINK: 'Copy link',
  COPIED: 'Copied!'
};
var COPY_TIMEOUT = 3000;
var Wrapper = styled.div(_templateObject());
var Content = styled.div(_templateObject2(), baselineToRem(3), baselineToRem(4));
export function CopyButton(_a) {
  var textToCopy = _a.textToCopy,
      buttonTitle = _a.buttonTitle,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? React.createElement(Icon, {
    name: "link",
    size: 24
  }) : _a$icon,
      _a$includePopover = _a.includePopover,
      includePopover = _a$includePopover === void 0 ? true : _a$includePopover,
      onCopyToClipboard = _a.onCopyToClipboard,
      iconButtonProps = __rest(_a, ["textToCopy", "buttonTitle", "icon", "includePopover", "onCopyToClipboard"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isCopied = _useState4[0],
      setCopied = _useState4[1];

  useEffect(function () {
    if (isCopied) {
      var timer = setTimeout(function () {
        setOpen(false);
        setCopied(false);
      }, COPY_TIMEOUT);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [isCopied]);

  var openPopover = function openPopover() {
    if (!isCopied) {
      setOpen(true);
    }
  };

  var closePopover = function closePopover() {
    if (!isCopied) {
      setOpen(false);
    }
  };

  var handleCopy = function handleCopy(text, result) {
    onCopyToClipboard && onCopyToClipboard();

    if (isCopied) {
      return;
    }

    if (result) {
      setCopied(true);
    }
  };

  var popoverTriggers = includePopover ? {
    onMouseEnter: openPopover,
    onMouseLeave: closePopover,
    onFocus: openPopover,
    onBlur: closePopover
  } : {};
  return React.createElement(Wrapper, null, React.createElement(CopyToClipboard, {
    text: textToCopy,
    onCopy: handleCopy
  }, React.createElement(IconButton, Object.assign({
    title: buttonTitle || TEXT.COPY_LINK,
    "aria-haspopup": true,
    "aria-expanded": isOpen
  }, popoverTriggers, iconButtonProps), icon)), includePopover && React.createElement(Popover, {
    width: 94,
    open: isOpen,
    position: "bottom center",
    triangleOffset: 38
  }, React.createElement(Content, null, isCopied ? TEXT.COPIED : TEXT.COPY_LINK)));
}